/* assets/go-personalize-logic.js — pure helpers for snippets/go-personalize.liquid.
   Browser: window.GoPersonalize. Node (tests/): module.exports. No DOM, no storage. */
(function (root) {
  var DAY = 86400000;
  var HOLDOUT_FROM_MS = Date.parse('2026-10-21T00:00:00-05:00');
  var HOLDOUT_SHARE = 0; // No holdout (Joe, 2026-10-02); set >0 to run a test.
  function str(v, max) { return typeof v === 'string' ? v.replace(/\s+/g, ' ').trim().slice(0, max) : ''; }
  function readProfile(raw) {
    if (!raw) return null;
    var o; try { o = JSON.parse(raw); } catch (e) { return null; }
    if (!o || typeof o !== 'object') return null;
    return {name: str(o.name, 40), awareness: str(o.awareness, 40), fn: str(o['function'], 40), pct: typeof o.pct === 'number' && o.pct > 0 && o.pct <= 100 ? o.pct : 0, at: typeof o.at === 'number' ? o.at : 0};
  }
  function segmentOf(p) {
    if (!p) return null;
    if (p.awareness === 'No') return 'new';
    if (p.awareness === 'Yes' || p.awareness === "I'm already a fan") return 'known';
    return null;
  }
  function headlineFor(p, segment) {
    var fn = p && p.fn;
    if (fn === 'Just beer, please') return 'Our most beer-tasting beers';
    if (fn === 'Relaxation') return 'Your evening beer';
    return segment === 'new' ? 'New to Go? Start here' : 'New this month';
  }
  // Copy for the "top picks" section. name: quiz name or logged-in first name (may be blank).
  function firstName(n) {
    var t = str(n, 40).split(' ')[0] || '';
    return t ? t.charAt(0).toUpperCase() + t.slice(1) : '';
  }
  function picksIntro(p, segment, name) {
    var fn = p && p.fn, nm = firstName(name);
    var headline = nm ? nm + ', we\'ve got some top picks for you' : 'We\'ve got some top picks for you';
    var sub;
    if (fn === 'Relaxation') sub = 'You said you drink to unwind, so these are our best evening beers.';
    else if (fn === 'Just beer, please') sub = 'You said you just want beer, so these are the ones that taste most like it.';
    else if (segment === 'new') sub = 'New to Go? These are the beers most people start with.';
    else if (segment === 'known') sub = 'What\'s new this month, for people who already know us.';
    else sub = 'A few of our favorites to start with.';
    return {eyebrow: 'Picked for you', headline: headline, sub: sub};
  }
  function variantFor(seed, nowMs) {
    if (nowMs < HOLDOUT_FROM_MS) return 'on';
    return seed < HOLDOUT_SHARE ? 'holdout' : 'on';
  }
  function pushRecent(list, item) {
    if (!item || !item.handle) return list;
    var first = {handle: item.handle, title: str(item.title, 80)};
    if (typeof item.sid === 'string' && item.sid) first.sid = item.sid.slice(0, 40);
    var out = [first];
    (list || []).forEach(function (x) { if (x && x.handle && x.handle !== item.handle && out.length < 3) out.push(x); });
    return out;
  }
  function recentFromEarlierSessions(list, sid) {
    return (list || []).filter(function (x) { return x && x.handle && x.sid && x.sid !== sid; });
  }
  function picksAvailable(picks) {
    var ok = (picks || []).filter(function (p) { return p && p.available; });
    return ok.length >= 2 ? ok : [];
  }
  function showWelcome(o) {
    var p = o.profile;
    if (!p || !p.name || !p.at) return false;
    if ((o.ordersCount || 0) > 0) return false;
    if (o.nowMs - p.at < 30 * 60000) return false; // a return visit, not the session they took the quiz in
    if (o.nowMs - p.at > 30 * DAY) return false;
    if (o.dismissedAt && o.nowMs - o.dismissedAt < 7 * DAY) return false;
    return true;
  }
  function welcomeLine(o) {
    var nm = firstName(o.name);
    var s = (nm ? 'Yo ' + nm + ', here\'s' : 'Here\'s') + ' some stuff we picked for you.';
    if (o.pct > 0) s += ' Your ' + o.pct + '% cash back is still waiting.';
    return s;
  }
  var api = {readProfile: readProfile, segmentOf: segmentOf, headlineFor: headlineFor, variantFor: variantFor, pushRecent: pushRecent, recentFromEarlierSessions: recentFromEarlierSessions,
    picksAvailable: picksAvailable, picksIntro: picksIntro, firstName: firstName, showWelcome: showWelcome, welcomeLine: welcomeLine, HOLDOUT_FROM_MS: HOLDOUT_FROM_MS, HOLDOUT_SHARE: HOLDOUT_SHARE};
  if (typeof module !== 'undefined' && module.exports) module.exports = api; else root.GoPersonalize = api;
})(typeof window !== 'undefined' ? window : this);
